module.exports = __webpack_public_path__ + "img/shop.dbb0808e.svg";